import { GoldBtn } from '@/components/ui';
import { useScrolled } from '@/hooks/useScrolled';
import { assets, externalLinks } from '@/theme/tokens';
// import { scrollToReserve } from '@/utils/scroll';

/** Sticky top navigation: logo, demo link, and a small Reserve CTA. */
export function Nav() {
  const scrolled = useScrolled();

  return (
    <nav
      id="site-nav"
      style={{
        boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.5)' : 'none',
      }}
    >
      <img src={assets.logo} alt="QuestXR" style={{ height: 32, objectFit: 'contain' }} />
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <GoldBtn size="sm" variant="outlined" href={externalLinks.backerKit}>
          Reserve Now
        </GoldBtn>
        <GoldBtn size="sm" href={externalLinks.demo}>
          Play Free Now!
        </GoldBtn>
      </div>
    </nav>
  );
}
